import { render } from "./IconAltDown.vue?vue&type=template&id=01bd16cb"
import script from "./IconAltDown.vue?vue&type=script&lang=js"
export * from "./IconAltDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__